import { useContext } from 'react'
import { SiteDetailsContext } from '../contexts/siteDetailsContext'

export const useSiteDetails = () => {
  return useContext(SiteDetailsContext)
}
